import { ProjectGeoDataByIri } from 'src/constants/projectGeoData';
import {
  DATATYPE_IRIS,
  XSD_DECIMAL_IRI,
  XSD_DOUBLE_IRI,
  XSD_FLOAT_IRI,
  XSD_INTEGER_IRI,
} from 'src/templates/queries/iris';

const RANGES_BY_GEO_PROPERTY: Record<
  keyof ProjectGeoDataByIri,
  Set<typeof DATATYPE_IRIS[number]> | null
> = {
  loc: null,
  lat: new Set([
    XSD_DECIMAL_IRI,
    XSD_DOUBLE_IRI,
    XSD_FLOAT_IRI,
    XSD_INTEGER_IRI,
  ]),
  long: new Set([
    XSD_DECIMAL_IRI,
    XSD_DOUBLE_IRI,
    XSD_FLOAT_IRI,
    XSD_INTEGER_IRI,
  ]),
  nodeSize: new Set([
    XSD_DECIMAL_IRI,
    XSD_DOUBLE_IRI,
    XSD_FLOAT_IRI,
    XSD_INTEGER_IRI,
  ]),
  popupTitle: null,
  popupContent: null,
  tooltipTitle: null,
  tooltipContent: null,
};

export const validateRangeForGeoProperty = (
  propertyKey: keyof ProjectGeoDataByIri,
  rangeIri: typeof DATATYPE_IRIS[number]
) => {
  const ranges = RANGES_BY_GEO_PROPERTY[propertyKey];
  return ranges ? ranges.has(rangeIri) : true;
};
